<template>
    <div class="components-container" id="mobileMainBody" style="margin: 0;">
        <!-- 页头 -->
        <div class="headerMain">
            <!-- logo -->
            <div class="top_logo inlineRight">
                <!-- <img :src="logoImg" alt="logo" height="100%" /> -->
                <div style="margin-top:20px; color:#ffffff; font-size:28px;">教务管理系统</div>
            </div>
            <div class="right_box inlineRight text-right">
                <div>
                    <div class="customButton">
                        <div class="username"><i class="el-icon-user"></i>&nbsp;{{ userName }}</div>
                    </div>
                    <div v-if="pwdChangeVisible" class="customButton" @click="changePsw">
                        <div class="username"><i class="el-icon-lock"></i>&nbsp;修改密码</div>
                    </div>
                    <div v-if="exitVisible" class="customButton" @click="logout">
                        <div class="username"><i class="el-icon-switch-button"></i>&nbsp;退出</div>
                    </div>
                </div>
            </div>
            <!--
            <div class="right_box inlineRight text-right">
                <span class="userImg"><img :src="userImg" alt="exit" height="100%" /></span>
                <span class="username">{{userName}}</span>
                <div v-if="exitVisible" class="iconImg" @click="logout"><img :src="exitImg" alt="exit" height="100%" /></div>
            </div>
            -->
        </div>
        <!-- 中心 -->
        <div class="mainMain" :style="defaultHeight">
            <!-- 中心背景 -->
            <!-- <div class="mainBg">
                <div class="topbg">
                    <img :src="bgTopImg" alt="" width="100%">
                </div>
                <div class="bottomBg">
                    <img :src="bgBottomImg" alt="" width="100%">
                    <div class="titleBg">
                        <img :src="bgTitleImg" alt="" width="100%">
                    </div>
                </div>
            </div> -->
            <!-- 中心内容 -->
            <div class="mainNr">
                <!-- pc -->
                <!-- 走马灯 点击 不自动播放 不需要底部的指示器 两边箭头总是显示-->
                <el-carousel class="pcBox" trigger="click" :autoplay="false" indicator-position="none" arrow="always">
                    <el-carousel-item class="itemOne" v-for="item in 1" :key="item">
                        <div class="card-box">
                            <!-- 菜单列表 -->
                            <div v-if="item.visible && verifyAuth(item.auth)" class="cardBg inlineRight" v-for="(item,index) in card" :key="index">
                                <div class="cardMain" @click="showModule(item.url)">
                                    <div class="cardImg">
                                        <img :src="item.img" alt="">
                                    </div>
                                    <div class="cardName text-center">
                                        <h3 v-html="item.name"></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <!-- 手机端 -->
                <div class="phoneBox">
                    <!-- 菜单列表 -->
                    <div v-if="item.visible && verifyAuth(item.auth)" class="cardBg inlineRight" v-for="(item,index) in card" :key="index">
                        <div class="cardMain" @click="showModule(item.url)">
                            <div class="cardImg">
                                <img :src="item.img" alt="">
                            </div>
                            <div class="cardName text-center">
                                <h3 v-html="item.name"></h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 页脚 -->
        <div class="footerMain"></div>
    </div>
</template>

<script>
    import { globalConfig } from 'static/config'

    export default {
        name: 'mobileHomePage',
        data() {
            return {
                userName: null,
                userRole: [],
                exitVisible: false,
                logoImg: require("image/homePage/logo.png"), //logo
                bgTopImg: require('image/homePage/mainTop.jpg'), //中间背景上部分
                bgBottomImg: require('image/homePage/mainBottom.jpg'), //中间背景下部分
                bgTitleImg: require('image/homePage/mainTitle.png'), //中间背景标题
                userImg: require('image/homePage/userImg.png'), //用户标签
                pswImg: require('image/homePage/pswImg.png'), //用户标签
                exitImg: require('image/homePage/exitImg.png'), //退出
                defaultHeight: {
                    height: "", //判断中间内容的高度
                    background: "",
                },
                card: [
                    // {
                    //     name: "课表查询",
                    //     img: require('image/homePage/xxk.png'),
                    //     url: '/m/wx/timetable',
                    //     auth: ['1','5','8'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "教学场地申请",
                    //     img: require('image/homePage/jcxx.png'),
                    //     url: '/m/wx/siteApply',
                    //     auth: ['1','5'],
                    //     visible: false,
                    // },
                    // {
                    //     name: "调课申请",
                    //     img: require('image/homePage/tkgl.png'),
                    //     url: '/m/wx/adjustClasses',
                    //     auth: ['1','5'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "选修选课",
                    //     img: require('image/homePage/jcxx.png'),
                    //     url: '/m/wx/electiveSelection',
                    //     auth: ['1','8'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "体育选课",
                    //     img: require('image/homePage/jcxx.png'),
                    //     url: '/m/wx/sportElectiveSelection',
                    //     auth: ['1','8'],
                    //     visible: false,
                    // },
                    // {
                    //     name: "考试查询",
                    //     img: require('image/homePage/kwgl.png'),
                    //     url: '/m/wx/examSchedule',
                    //     auth: ['1','5','8'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "特殊成绩申请",
                    //     img: require('image/homePage/cjgl.png'),
                    //     url: '/m/wx/specialScoreApply',
                    //     auth: ['1','8'],
                    //     visible: false,
                    // },
                    // {
                    //     name: "成绩查询",
                    //     img: require('image/homePage/cjcx.png'),
                    //     url: '/m/wx/stuPersonalScore',
                    //     auth: ['1','8'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "学籍异动",
                    //     img: require('image/homePage/xsgl.png'),
                    //     url: '/m/wx/status',
                    //     auth: ['1','8'],
                    //     visible: false,
                    // },
                    // {
                    //     name: "重/补修申请",
                    //     img: require('image/homePage/cxsq.png'),
                    //     url: '/m/wx/retakeApply',
                    //     auth: ['1','8'],
                    //     visible: false,
                    // },
                    // {
                    //     name: "学分认定",
                    //     img: require('image/homePage/wkgl.png'),
                    //     url: '/m/wx/credit',
                    //     auth: ['1','5','8'],
                    //     visible: false,
                    // },
                    // {
                    //     name: "评教服务",
                    //     img: require('image/homePage/pjgl.png'),
                    //     url: '/m/wx/questionnaireSurveyMobile',
                    //     auth: ['1','8'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "考证考级报名",
                    //     img: require('image/homePage/kzkjbm.png'),
                    //     url: '/m/wx/outsideStudentSelection',
                    //     auth: ['1','8'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "实习信息",
                    //     img: require('image/homePage/jcxx.png'),
                    //     url: '/m/wx/stuPracticeMobile',
                    //     auth: ['1','8'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "实习管理",
                    //     img: require('image/homePage/jcxx.png'),
                    //     url: '/m/wx/practiceManageMobile',
                    //     auth: ['1','7','17','21','22'],
                    //     visible: true,
                    // },
                    // {
                    //     name: "在校证明",
                    //     img: require('image/homePage/cjgl.png'),
                    //     url: '/m/wx/atSchoolCertificateStuMobile',
                    //     auth: ['1','8'],
                    //     visible: true,
                    // },
                    {
                        name: "教师<br/>成人教育课表",
                        img: require('image/homePage/xxk.png'),
                        url: '/m/wx/teaTimetableDirectAdultEducationMobile',
                        auth: ['1','5'],
                        visible: true,
                    },
                    {
                        name: "教师<br/>技能培训课表",
                        img: require('image/homePage/xxk.png'),
                        url: '/m/wx/teaTimetableDirectSkillsTrainingMobile',
                        auth: ['1','5'],
                        visible: true,
                    },
                    {
                        name: "学生<br/>成人教育选课",
                        img: require('image/homePage/jcxx.png'),
                        url: '/m/wx/studentSelectionSportAdultEducationMobile',
                        auth: ['1','8'],
                        visible: true,
                    },
                    {
                        name: "学生<br/>成人教育课表",
                        img: require('image/homePage/xxk.png'),
                        url: '/m/wx/stuTimetableAdultEducationMobile',
                        auth: ['1','8'],
                        visible: true,
                    },
                    {
                        name: "学生<br/>成人教育<br/>成绩查询",
                        img: require('image/homePage/cjcx.png'),
                        url: '/m/wx/stuPersonalScoreAdultEducationMobile',
                        auth: ['1','8'],
                        visible: true,
                    },
                    {
                        name: "学生<br/>技能培训课表",
                        img: require('image/homePage/xxk.png'),
                        url: '/m/wx/stuTimetableSkillsTrainingMobile',
                        auth: ['1','8'],
                        visible: true,
                    },
                    {
                        name: "学生<br/>技能培训<br/>成绩查询",
                        img: require('image/homePage/cjcx.png'),
                        url: '/m/wx/stuPersonalScoreSkillsTrainingMobile',
                        auth: ['1','8'],
                        visible: true,
                    },
                    {
                        name: "学生<br/>技能认定<br/>成绩查询",
                        img: require('image/homePage/cjcx.png'),
                        url: '/m/wx/stuServicesAssessmentListMobile',
                        auth: ['1','8'],
                        visible: true,
                    },
                ],
                pwdChangeVisible: false,
            }
        },
        created() {
            //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
            window.addEventListener("resize", this.getHeight);
            this.getHeight();
            this.queryUserInfo();
        },
        mounted() {
            if(this.$route.path.indexOf('/m/wx/home') < 0){
                this.exitVisible = true;
            }
            this.pwdChangeVisible = !globalConfig.CASSWITCH;
        },
        methods: {
            getHeight() {
                if ($(window).width() < 750) {
                    this.defaultHeight.height = window.innerHeight - 180 + "px";
                    this.defaultHeight.background = 'url('+require('image/homePage/newsBg.jpg')+') no-repeat center';
                } else {
                    this.defaultHeight.height = window.innerHeight - 160 + "px";
                    this.defaultHeight.background = 'url('+require('image/homePage/newsBg.jpg')+') no-repeat';
                }
            },
            queryUserInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;

                    if (userInfo) {
                        this.userName = userInfo.name;
                        let roleInfo = userInfo.roles;

                        for (let roleCode in roleInfo) {
                            this.userRole.push(roleCode);
                            // this.userRole.push('8');
                        }
                    } else {
                        // this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            verifyAuth(auth){
                for(let i=0; i<auth.length; i++){
                    for(let j=0; j<this.userRole.length; j++){
                        if(auth[i] === this.userRole[j]){
                            return true;
                        }
                    }
                }
                return false;
            },
            showModule(url){
                this.$router.push({ path: url });
            },
            changePsw(){
                window.open(globalConfig.PSWURL, '_self');
            },
            logout() {
                this.$api.system.basic.userLogout({}).then((res) => {
                    if(res.status == 200){
                        localStorage.clear();

                        if (globalConfig.CASSWITCH) {
                            // let routeUrl = this.$router.resolve({
                            //     path: "/casLogoutAll"
                            // });
                            window.open(globalConfig.CASURL + '/logout?service=' + encodeURIComponent(globalConfig.DOMIN), '_self');
                        } else {
                            location.reload();
                        }
                    }else{
                        this.$message.error('登出失败，网络异常');
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$message.error('登出失败，网络异常');
                });
            },
        }
    }
</script>
<!-- #2f79c4 深绿 #f5f6f0 浅绿 #ffffff 白色-->
<style>
    #mobileMainBody {
        width: 100%;
        height: 100%;
        margin: 0;
    }

    #mobileMainBody .inlineRight {
        display: inline-block;
        float: left;
    }

    #mobileMainBody .text-center {
        text-align: center;
    }

    #mobileMainBody .text-right {
        text-align: right;
    }

    /*--------------------------------------- 头部 ---------------------------------------*/
    #mobileMainBody .headerMain {
        height: 100px;
        padding: 8px 1em;
        position: relative;
        background-color: #2f79c4;
        z-index: 2;
    }

    /* logo区域 */
    #mobileMainBody .headerMain .top_logo {
        height: 100%;
        width: 40%;
    }

    /* 右侧用户名区域 */
    #mobileMainBody .headerMain .right_box {
        /* line-height: 50px; */
        height: 100%;
        width: 60%;
        color: #fff;
    }

    /*
    #mobileMainBody .headerMain .right_box .userImg {
        display: inline-block;
        height: 45px;
        background: #fff;
        border-radius: 50%;
        padding: 8px;
        margin-right: 5px;
    }

    #mobileMainBody .headerMain .right_box .iconImg {
        display: inline-block;
        height: 50px;
        padding: 8px;
        margin-right: 5px;
        cursor: pointer;
    }
    */

    #mobileMainBody .headerMain .right_box .username {
        font-size: 18px;
        margin-right: 5px;
    }

    /*--------------------------------------- 中心 ---------------------------------------*/
    #mobileMainBody .mainMain {
        background-size: cover !important;
        position: relative;
    }

    #mobileMainBody .phoneBox {
        display: none;
    }

    /* 背景 */
    #mobileMainBody .mainMain .mainBg {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }

    #mobileMainBody .mainMain .mainBg .topbg {
        height: 50%;
        background: #f5f6f0;
        position: relative;
    }

    #mobileMainBody .mainMain .mainBg .topbg img {
        position: absolute;
        bottom: 0;
    }

    .mainMain .mainBg .titleBg {
        position: absolute;
        bottom: 0;
    }

    /* 内容 */
    #mobileMainBody .mainMain .mainNr {
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }

    /* 走马灯高度 */
    #mobileMainBody .mainMain .mainNr .el-carousel--horizontal,
    #mobileMainBody .mainMain .mainNr .el-carousel__container {
        height: 100%;
    }

    /* 左右箭头 */
    #mobileMainBody .mainMain .mainNr .el-carousel__arrow {
        background: transparent;
        height: auto;
        width: auto;
    }

    #mobileMainBody .mainMain .mainNr .el-carousel__arrow i:hover {
        color: #60a748;
    }

    #mobileMainBody .mainMain .mainNr .el-carousel__arrow i {
        font-size: 7em;
        color: #2f79c4;
    }

    #mobileMainBody .mainMain .mainNr .itemOne {
        padding: 4em 7em;
    }

    #mobileMainBody .mainMain .card-box {
        height: 100%;
        width: 100%;
    }

    #mobileMainBody .mainMain .cardBg {
        width: 25%;
        height: 33.3%;
        padding: 1em;
    }

    #mobileMainBody .mainMain .cardMain {
        height: 100%;
        width: 100%;
        border-radius: 15px;
        background-color: rgba(255, 255, 255, 0.8);
        box-shadow: 0 0 10px #e0e0e0;
    }

    #mobileMainBody .mainMain .cardMain:hover {
        cursor: pointer;
        transform: translateY(-5px);
    }

    #mobileMainBody .mainMain .cardMain .cardImg {
        height: 65%;
        text-align: center;
    }

    #mobileMainBody .mainMain .cardMain .cardImg img {
        height: 90%;
        margin-top: 15%;
    }

    #mobileMainBody .mainMain .cardMain .cardName h3 {
        margin: 0;
        //padding: 10px 5px;
        color: #6da1d6;
        font-size: 2vh;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        margin-top: 15%;
        display: inline-block;
    }

    #mobileMainBody .mainMain .cardMain .cardName small {
        overflow: hidden;
        padding: 0 5px;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        display: inline-block;
        color: #b3b3b3;
    }

    /*--------------------------------------- 页脚 ---------------------------------------*/
    #mobileMainBody .footerMain {
        background-color: #2f79c4;
        line-height: 60px;
        height: 60px;
        text-align: center;
        z-index: 2;
    }

    #mobileMainBody .footerMain a {
        color: #fff;
    }

    /*--------------------------------------- 响应式 ---------------------------------------*/
    @media all and (min-width: 750px) and (max-width:1000px) {
        #mobileMainBody .mainMain .cardBg {
            width: 33.3%;
            height: 25%;
        }

        #mobileMainBody .mainMain .cardMain .cardImg {
            height: 55%;
        }
    }

    /*------------------- 高度不够缩小图片 -------------------*/
    @media all and (max-height:1000px) {
        #mobileMainBody .mainMain .cardMain .cardImg {
            height: 55%;
        }
    }

    /*------------------- 手机端 -------------------*/
    @media all and (max-width:750px) {

        /* 隐藏pc */
        #mobileMainBody .pcBox {
            display: none;
        }

        /* 头部 */
        #mobileMainBody .headerMain {
            height: 120px;
        }

        #mobileMainBody .headerMain .top_logo {
            height: 68px;
            width: 100%;
            text-align: center;
        }

        #mobileMainBody .headerMain .right_box {
            width: 100%;
            height: 36px;
            line-height: 36px;
            margin-top: 5px;
        }

        #mobileMainBody .headerMain .right_box p {
            margin: 0;
        }

        /* 显示手机端 */
        #mobileMainBody .phoneBox {
            display: block;
            height: 100%;
            width: 100%;
            /* border:1px red solid; */
            overflow-x: hidden;
            overflow-y: auto;
        }

        #mobileMainBody .mainMain .cardBg {
            width: 33.3%;
            height: 180px;
            padding: 8px;
        }

        #mobileMainBody .mainMain .cardMain .cardImg {
            height: 50%;
        }
    }

    @media all and (max-width:400px) {
        #mobileMainBody .headerMain .top_logo img {
            width: 100%;
            height: auto;
        }
    }

    .customButton {
        display: inline-block;
        cursor: pointer;
    }

    .customButton:hover {
        color: #ff6146;
    }
</style>



// WEBPACK FOOTER //
// mobileHomePage.vue?542cb46e